import { render, staticRenderFns } from "./DetalhesIG.vue?vue&type=template&id=60512021"
import script from "./DetalhesIG.vue?vue&type=script&lang=js"
export * from "./DetalhesIG.vue?vue&type=script&lang=js"
import style0 from "./DetalhesIG.vue?vue&type=style&index=0&id=60512021&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports